import styles from './styles.scss';
import cn from 'classnames';

interface OwnProps {
  title?: string;
  className?: string;
}

const ProductCardFlag = ({ title, className }: OwnProps) => (
  <div className={cn(styles.productCardTitle, className)}>{title}</div>
);

export default ProductCardFlag;
